import CryptoJS from 'crypto-js'

let key = '51c016879f5c4ce4b686d7588f4dfb70'
key = CryptoJS.enc.Utf8.parse(key)
export const encryptKey = key

export const nameLength = 16
